/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import styled from "styled-components/macro";
import { NavLink,   useParams } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import Loading from "../components/Loading";
import * as _ from "lodash";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

import {

  Timeline,
  TimelineConnector,
  TimelineContent,
  TimelineDot,
  TimelineItem,
  TimelineOppositeContent,
  TimelineSeparator,
} from "@mui/lab";
import {
  CardContent,
  Grid,
  Link,
  Breadcrumbs as MuiBreadcrumbs,
  Card as MuiCard,
  Paper as MuiPaper,
  TextField,
  Typography,

  FormControl,
  FormControlLabel,
  Checkbox,
  AccordionSummary,
  Accordion,
  AccordionDetails,
} from "@mui/material";
import { spacing } from "@mui/system";
import { connect } from "react-redux";
import axios from "../../CustomAxios";
import moment from "moment";

const Card = styled(MuiCard)(spacing);


const Breadcrumbs = styled(MuiBreadcrumbs)(spacing);

const Paper = styled(MuiPaper)(spacing);

function FormDetails({ audits, user, details }) {
  const authData = JSON.parse(localStorage.getItem("AuthData"));

  return (
    <>
      <Card mb={6}>
        <CardContent>
          <Paper elevation={3} style={{ padding: "2%" }}>
            <Grid container spacing={5}>
              <Grid item xs={12} md={12} lg={12}>
                <Typography color="primary" variant="h6" gutterBottom>
                  Plate Details
                </Typography>
              </Grid>
              <Grid item xs={12} md={12} lg={12}>
                <TextField
                  type="text"
                  fullWidth
                  label="Brand"
                  value={details?.brand?.name}
                  inputProps={{ readOnly: true }}
                />
              </Grid>
              <Grid item xs={12} md={12} lg={12}>
                <TextField
                  type="text"
                  fullWidth
                  label="Technology"
                  value={details?.technology?.name}
                  inputProps={{ readOnly: true }}
                />
              </Grid>
              <Grid item xs={12} md={12} lg={12}>
                <TextField
                  type="text"
                  fullWidth
                  label="Company"
                  value={details?.company}
                  inputProps={{ readOnly: true }}
                />
              </Grid>
              <Grid item xs={12} md={3} lg={3}>
                <TextField
                  fullWidth
                  type="number"
                  label="Height"
                  value={details?.height}
                  inputProps={{ readOnly: true }}
                />
              </Grid>
              <Grid item xs={12} md={3} lg={3}>
                <TextField
                  fullWidth
                  type="number"
                  label="Width"
                  value={details?.height}
                  inputProps={{ readOnly: true }}
                />
              </Grid>
              <Grid item xs={12} md={3} lg={3}>
                <TextField
                  fullWidth
                  type="number"
                  label="Thickness"
                  value={details?.thickness}
                  inputProps={{ readOnly: true }}
                />
              </Grid>
              <Grid item xs={12} md={3} lg={3}>
                <TextField
                  type="text"
                  fullWidth
                  label="HSN/SAC"
                  value={details?.hsn}
                  inputProps={{ readOnly: true }}
                />
              </Grid>

              <Grid item xs={12} lg={3} md={3}>
                <FormControl fullWidth component="fieldset" variant="standard">
                  <FormControlLabel
                    control={<Checkbox checked={details?.is_deleted} />}
                    label={"IS DELETED"}
                  />
                </FormControl>
              </Grid>
            </Grid>
          </Paper>
        </CardContent>
      </Card>

      {user?.role?.permissions.includes("view_plate_audit_logs") ||
      authData?.type === "super_admin" ? (
        <Card mb={6}>
          <CardContent>
            <Paper elevation={3} style={{ padding: "2%" }}>
              <Grid container spacing={5}>
                <Grid item xs={12} md={12} lg={12}>
                  <Accordion>
                    <AccordionSummary
                      expandIcon={<ExpandMoreIcon />}
                      aria-controls="panel1a-content"
                      id="panel1a-header"
                    >
                      <Typography color="primary" variant="h6" gutterBottom>
                        Audit Logs
                      </Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                      <Grid item xs={12} md={12} lg={12}></Grid>
                      <Timeline position="alternate">
                        {audits.map((audit, ind) => {
                          return ind % 2 === 0 ? (
                            <TimelineItem>
                              <TimelineOppositeContent
                                align="right"
                                variant="body2"
                                color="secondary"
                              >
                                <br />

                                {moment(audit?.audit_logs?.timestamp).format(
                                  "MMM DD, YYYY"
                                )}
                                <br />
                                {moment(audit?.audit_logs?.timestamp).format(
                                  " hh:mm A"
                                )}
                              </TimelineOppositeContent>
                              <TimelineSeparator>
                                <TimelineConnector />
                                <TimelineDot color="primary" variant="outlined">
                                  {/* <FastfoodIcon /> */}
                                </TimelineDot>
                                <TimelineConnector />
                              </TimelineSeparator>
                              <TimelineContent>
                                <Typography variant="h6" component="span">
                                  {_.upperCase(audit?.audit_logs?.action)}
                                </Typography>
                                <Typography variant="body1">
                                  By-
                                  {audit?.audit_logs?.user_details?.name ||
                                    "Super Admin"}
                                </Typography>
                                <Typography variant="body2">
                                  {_.upperCase(audit?.audit_logs?.user_type) ||
                                    "SUPER ADMIN"}
                                </Typography>
                              </TimelineContent>
                            </TimelineItem>
                          ) : (
                            <TimelineItem>
                              <TimelineOppositeContent
                                variant="body2"
                                color="secondary"
                              >
                                <br />

                                {moment(audit?.audit_logs?.timestamp).format(
                                  "MMM DD, YYYY"
                                )}
                                <br />
                                {moment(audit?.audit_logs?.timestamp).format(
                                  " hh:mm A"
                                )}
                              </TimelineOppositeContent>
                              <TimelineSeparator>
                                <TimelineConnector />
                                <TimelineDot color="primary">
                                  {/* <LaptopMacIcon /> */}
                                </TimelineDot>
                                <TimelineConnector />
                              </TimelineSeparator>
                              <TimelineContent>
                                <Typography variant="h6" component="span">
                                  {_.upperCase(audit?.audit_logs?.action)}
                                </Typography>
                                <Typography variant="body1">
                                  By-{" "}
                                  {audit?.audit_logs?.user_details?.name ||
                                    "Super Admin"}
                                </Typography>
                                <Typography variant="body2">
                                  {_.upperCase(audit?.audit_logs?.user_type) ||
                                    "SUPER ADMIN"}
                                </Typography>
                              </TimelineContent>
                            </TimelineItem>
                          );
                        })}
                      </Timeline>
                    </AccordionDetails>
                  </Accordion>
                </Grid>
              </Grid>
            </Paper>
          </CardContent>
        </Card>
      ) : null}
    </>
  );
}

const getPlateDetails = async (id, setMyState) => {
  try {
    const authData = JSON.parse(localStorage.getItem("AuthData"));
    const config = {
      headers: {
        Authorization: "Bearer " + authData?.access_token,
      },
    };
    const { data } = await axios.get(
      `/api/v1/${authData?.type}/plate_inventory/${id}/details`,
      config
    );
    if (data.success) {
      setMyState((prev) => {
        return { ...prev, details: data.data };
      });
    }
    const audit = await axios.get(
      `/api/v1/${authData?.type}/plate_inventory/${id}/audit_logs`,
      config
    );
    if (audit.data.success) {
      setMyState((prev) => {
        return { ...prev, audits: audit.data.data };
      });
    }
    setMyState((prev) => {
      return { ...prev, loader: false };
    });
  } catch (e) {
    setMyState((prev) => {
      return { ...prev, loader: false };
    });
  }
};

function PlateDetails({ auths }) {
  const { plate_id } = useParams();
  const [myState, setMyState] = useState({
    audits: [],
    details: [],
    loader: true,
    user: auths?.user,
  });
  useEffect(() => {
    getPlateDetails(plate_id, setMyState);
  }, []);
  if (!myState.loader) {
    return (
      <React.Fragment>
        <Helmet title="Alpha Plus" />
        <Grid
          justifyContent="space-between"
          alignItems="center"
          container
          spacing={10}
          mb={4}
        >
          <Grid item>
            <Typography
              variant="h4"
              gutterBottom
              display="inline"
              sx={{ fontWeight: 600 }}
              color="primary"
            >
              PLATE DETAILS
            </Typography>
          </Grid>
          <Grid item>
            <Breadcrumbs aria-label="Breadcrumb" mt={2}>
              <Link component={NavLink} to="/dashboard/tasks">
                Dashboard
              </Link>
              <Link component={NavLink} to="/dashboard/inventory">
                Inventory
              </Link>
              <Typography>Plate Details</Typography>
            </Breadcrumbs>
          </Grid>
        </Grid>

        <Grid container spacing={6}>
          <Grid item xs={12}>
            {/* <GeneralDetails /> */}
            <FormDetails
              audits={myState.audits}
              user={myState.user}
              details={myState.details}
            />
          </Grid>
        </Grid>
      </React.Fragment>
    );
  } else {
    return <Loading />;
  }
}

const mapStateToProps = (state) => ({
  auths: state.auths,
});

export default connect(mapStateToProps, null)(PlateDetails);
